import {fork, select} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {parseTileId} from "../../../shared/utils/parseTileId";
import {preloadTileImages} from "./tileHandlers/preloadTileImages";

export default function* preloadLevelMap(levelId: number) {
    const {questions, levelMap, revealedTiles} = yield select(({ game }: IApplicationState) => {
        return {
            questions: game.questions,
            levelMap: game.levelMaps[levelId] && game.levelMaps[levelId].tiles,
            revealedTiles: Object.entries(game.levelMapTileProgress)
                .filter(([, tile]) => {
                    if (!tile.isRevealed || tile.isAnswered)
                        return false;

                    const {level} = parseTileId(tile.id);
                    return level === levelId;
                })
                .map(([, tile]) => tile),
        };
    });

    if (!levelMap || !revealedTiles.length)
        return;

    yield fork(preloadTileImages, questions, levelMap, revealedTiles);
}